@if (!isIncomplete) {
  <wc-wrapper [contentWrapper]="wrapper">
    <wc-base-faq sd-component-wrapper-component [sdSpyTarget]="componentUid" [faqEntries]="faqs" />
  </wc-wrapper>
}
